import {
    CREATE_WASHING_INWARD_DETAILS_REQUEST_DK,
    CREATE_WASHING_INWARD_DETAILS_SUCCESS_DK,
    CREATE_WASHING_INWARD_DETAILS_FAILURE_DK,
    DELETE_WASHING_INWARD_DETAILS_REQUEST_DK,
    DELETE_WASHING_INWARD_DETAILS_SUCCESS_DK,
    DELETE_WASHING_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_WASHING_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_WASHING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_WASHING_INWARD_DETAILS_FAILURE_DK,
    FETCH_WASHING_INWARD_DETAILS_REQUEST_DK,
    FETCH_WASHING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_WASHING_INWARD_DETAILS_FAILURE_DK,
    UPDATE_WASHING_INWARD_DETAILS_REQUEST_DK,
    UPDATE_WASHING_INWARD_DETAILS_SUCCESS_DK,
    UPDATE_WASHING_INWARD_DETAILS_FAILURE_DK,
    RESET_WASHING_INWARD_DETAILS_INFO_DK,
    CREATE_WASHING_INWARD_DETAILS_FORM_DK,
    UPDATE_WASHING_INWARD_DETAILS_FORM_DK,
    FETCH_WASHING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK,
    FETCH_PREVIOUS_WASHING_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_WASHING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_WASHING_INWARD_DETAILS_FAILURE_DK
} from './washingInwardDetails.actionsType';

export const WASHING_INWARD_DK_DETAILS = 'washingInwardDKDetails';

let initialState = {
    loading: false,
    washingInwardDetails: [],
    washingInwardDetailsWithoutId: [],
    previousGetList: [],
    washingInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldReceivingRolls: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0
    },
    selectedState: {},
    errorMessage: ''
};

export let washingInwardDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_WASHING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_PREVIOUS_WASHING_INWARD_DETAILS_REQUEST_DK:
        case CREATE_WASHING_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_WASHING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_WASHING_INWARD_DETAILS_REQUEST_DK:
        case DELETE_WASHING_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_WASHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingInwardDetails: updatePayload
            };
        case FETCH_PREVIOUS_WASHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload
            };
        case FETCH_WASHING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingInwardDetailsWithoutId: updatePayload
            };
        case CREATE_WASHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case UPDATE_WASHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case FETCH_SINGLE_WASHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingInwardDetailsForm: updatePayload
            };
        case DELETE_WASHING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                washingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case RESET_WASHING_INWARD_DETAILS_INFO_DK:
            return {
                ...state,
                washingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case CREATE_WASHING_INWARD_DETAILS_FORM_DK:
        case UPDATE_WASHING_INWARD_DETAILS_FORM_DK:
            return {
                ...state,
                loading: false,
                washingInwardDetailsForm: {
                    ...state.washingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_WASHING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_WASHING_INWARD_DETAILS_FAILURE_DK:
        case CREATE_WASHING_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_WASHING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_WASHING_INWARD_DETAILS_FAILURE_DK:
        case DELETE_WASHING_INWARD_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
